import { axiosInstanceV2 } from "@src/shared/api";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { REQUEST_HH_API_URL } from "../constants";

//Поправить после бека
export interface TСreateRequestHHDto {
  type: string;
  vacancy_description: string;
  text?: string;
  area?: string[];
  education_levels?: string[];
  experience?: string[];
  label?: string;
  key_skills?: string[];
  salary_from?: number;
  salary_to?: number;
  job_search_status?: string[];
  formated_skills: string | null;
  citizenship?: boolean;
  job_format?: string[];
  work_format_ids?: string[];
  match_without_salary: boolean;
  match_without_age: boolean;
  exclude_jumpers: boolean;
  resume_search_relocation?: string[];
  age_from?: string | null;
  age_to?: string | null;
  exclusion_criteria?: string[] | null;
  gender?: string;
  requires_car: boolean | null;
  required_skills?: string[];
  nice_to_have_skills?: string[];
  must_have_skills?: string[];
  vacancy_name?: string;
  is_edu_optional?: boolean;
  requirements?: {
    mandatory: string[];
    priority: string[];
    optional: string[];
  };
}

export type TСreateRequestHHDto2 = {
  salary_to: number | null;
  work_experience_from: number | null;
  work_experience_to: number | null;
  age_from: number | null;
  age_to: number | null;
  exclude_job_hoppers: boolean;
  requires_car: boolean | null;
  requirements: {
    mandatory: string[];
    priority: string[];
    optional: string[];
  };
  company_industry: string;
  exclusion_criteria: string[];
  location_ids: string[];
  work_format_ids: string[];
  education_id?: string | null;
  gender_id: string | null;
  grade_ids: {
    system_id: string | null;
    level_ids: string[];
  };
  salary_from: number | null;
  relocation_types_ids: string[];
  match_without_salary: boolean;
  job_search_status_ids: string[];
  match_without_age: boolean;
  rf_citizenship: boolean;
  vacancy_name: string;
  grade_labels: {
    system_label: string | null;
    level_labels: string[];
  };
  car_license: string[];
  education_type?: string | null;
  is_edu_optional?: boolean;
};

export const createRequestHH = (data: TСreateRequestHHDto2) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.post(REQUEST_HH_API_URL.createRequestHH(), data, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};
